import globals from '../globals';
import creator from '../elementCreator';
//import 'jquery-ui/ui/widget';
//import 'jquery-ui/ui/widgets/mouse';
//import 'jquery-ui/ui/widgets/sortable';
//import 'jquery-ui/ui/widgets/droppable';
//Kommentert ut kode for flytting og sortering av kartlag. Legges tilbake når sortable vil virke. ref: ":data"
var privateFns, mapInteractions, clickFns, parameters, remove;

parameters = {
	selectedColor: "black",
	interaction: undefined,
	btn: undefined,
},
mapInteractions = {
	getActiveInteractions: function () {
		var interactions = {};
		globals.map.getInteractions().forEach(function (i) {
			if (i.get("itype") === "draw") {
				interactions.measureInteraction = i;
			} else if (i.get("interactionId") === "featurehover") {
				interactions.mapHoverInteraction = i;
			} else if (i.get("featurehover") === "featureclick") {
				interactions.mapClickInteraction = i;
			}
		});
		return interactions;
	},
},
privateFns = {
	updateSliderPanel: function(){
		document.getElementById("slider-container").innerHTML = "";
		let activeLayers = privateFns.getActiveLayers(globals.map.getLayers());
		activeLayers.forEach(function(layer){				
			document.getElementById("slider-container").appendChild(privateFns.addSliders(layer));
		});
	},
	getActiveLayers: function(layers){
		var activeLayers = [];
		layers.forEach(function(layer){
			let id = layer.get("layerId");
			if(!layer.getLayers && document.getElementById(id) && id !== "situasjon" && id !== "no_historisk_flyfoto" && id !== "text1" && document.getElementById(id).checked){
				activeLayers.push(layer);
			}else if(layer.getLayers){
				activeLayers = [...activeLayers, ...privateFns.getActiveLayers(layer.getLayers())];
			}
		});
		return activeLayers;
	},
	addSliderControlPanel(){
		let activeLayers = privateFns.getActiveLayers(globals.map.getLayers());
		//activeLayers = activeLayers.splice(0, 1)
		
		var panel, textField, updateBtn, infoBtn, removeBtn;
		panel = creator.createDiv({
			css: "map-writer-panel",
			id: "map-slider-panel",
		});
		updateBtn = creator.createButton({
			icon: true,
			iconClass: "fa fa-refresh",
			ariaLabel: "Oppdater kartlag",
			id: "fjernBtn",
			title: "Oppdater kartlag",
			onclick: function(evt){
				privateFns.updateSliderPanel();
			}
		});
		updateBtn.style.float = "right";
		panel.appendChild(updateBtn);
		infoBtn = creator.createButton({
			icon: true,
			iconClass: "icon-Informasjon",
			ariaLabel: "Info om verktøy",
			id: "slider-info-btn",
			title: "Informasjon om verktøyet",
			onclick: function(evt){
				$("#planinnsyn-hjelp").click();
				$("#tool-info-btn").click();
			}
		});
		infoBtn.style.float = "right";
		panel.appendChild(infoBtn);
		let sliderContainer = creator.createUl({id: "slider-container"});
		sliderContainer.style.listStyleType = "none";
		sliderContainer.style.paddingLeft = 0;
		panel.appendChild(sliderContainer);
		activeLayers.forEach(function(layer){				
			sliderContainer.prepend(privateFns.addSliders(layer));
		});
		document.getElementById("map").appendChild(panel);
		
		/*$("#slider-container").sortable({
			update: function(){
				privateFns.orderLayers();
			},
			handle: ".handle",
			cursor: "move",
			items: "data"
		});
		$("#slider-container li" ).droppable();
		*/
		$("#map-slider-panel").show();
	},
	addSliders: function (layer) {
		var li, ct, id;
		id = layer.get("title");
		li = creator.createLi({id: id + "-swiper-container"});
		let nameDiv = creator.createDiv({text: id, });
		li.appendChild(nameDiv);
		let swiper = privateFns.addLayerSlider(layer, id);
		li.appendChild(swiper);
		privateFns.addSliderHandler(layer, swiper);
		let OPSlider = privateFns.addOpacitySlider(layer, id);
		li.appendChild(OPSlider);
		//li.appendChild(privateFns.createMover(layer));
		li.setAttribute("data", layer.values_.layerId);
		privateFns.addOpacityHandler(layer, OPSlider);
		$(li).show();
		return li;
	},
	dragstart: function(e){
		var index = $(e.target).index();
		e.dataTransfer.setData('text/plain', index);
	},
	dropped: function(e){
		privateFns.cancelDefault(e)
		// get new and old index
		let oldIndex = e.dataTransfer.getData('text/plain');
		let target = $(e.target).closest("li");
		let newIndex = target.index()
		if (oldIndex != newIndex){				
			// remove dropped items at old place
			let dropped = $(this).parent().children().eq(oldIndex).remove()

			// insert the dropped items at new place
			if (newIndex < oldIndex) {
				target.before(dropped)
			} else {
				target.after(dropped)
			}
			privateFns.orderLayers();
		}
	},
	cancelDefault: function(e){
		e.preventDefault();
		e.stopPropagation();
		return false;
	},
	orderLayers: function(){
		console.log("tets");
		let importLayers = document.getElementById("slider-container").getElementsByTagName("li");
		for(let i = 0; i < importLayers.length; i++){
			globals.map.getLayerById(importLayers[i].getAttribute("data")).setZIndex(importLayers.length - i);
		}
	},
	addLayerSlider: function(layer, id){
		var swiper = creator.createInput({id: id + "-swipe", type: "range"});
		swiper.value = 0;
		return swiper;
	},
	addOpacitySlider: function(layer, id){
		var slider = creator.createInput({id: id + "-opacity", type: "range"});
		slider.value = 100;
		return slider;
	},
	createMover: function(l){
		let span = creator.createSpan({text: "Dra for å flytte", css: "handle"});
		span.style.marginTop = "5px";
		let icon = creator.createIcon({css: "fa fa-arrows"});
		span.append(icon);
		return span;
	},
	addSliderHandler: function(layer, swipe){
		//var swipe = document.getElementById(layer.get("layerId") + '-swipe');

		layer.on(["precompose", "prerender"], function(event) {
			var ctx = event.context;
			var width = ctx.canvas.width * (swipe.value / 100);
			ctx.save();
			ctx.beginPath();
			ctx.rect(width, 0, ctx.canvas.width - width, ctx.canvas.height);
			ctx.clip();
		});

		layer.on(["postcompose", "postrender"], function(event) {
			var ctx = event.context;
			ctx.restore();
		});

		swipe.addEventListener('input', function() {
			layer.getSource().changed();
		}, false);
	},
	
	addOpacityHandler: function(layer, swipe){
		swipe.addEventListener('input', function() {
			layer.setOpacity(swipe.value/100);
			layer.getSource().changed();
		}, false);
	},
	
	writeOnMap: function(btn){
		var panel = $("#map-slider-panel");
		btn.toggleClass("selected");
		if (!btn[0].classList.contains("selected")) {
			privateFns.deactivate(btn);
		} else {
			if(panel[0]){
				panel.show();
			}else{
				privateFns.addSliderControlPanel();
			}
		}
	},
	deactivate: function(btn){
		var panel = $("#map-slider-panel");
		var interactions = mapInteractions.getActiveInteractions();
		globals.map.removeInteraction(parameters.interaction);
		panel.hide();
		globals.mapclick = true;
		if (interactions.mapClickInteraction) {
			interactions.mapClickInteraction.setActive(true);
		}
		interactions.mapHoverInteraction.setActive(true);
		if(btn.removeClass){
			btn.removeClass("selected");
			btn.blur();
		}
	},
	mapSliderClick: function(e){
		var btn = $(e.currentTarget);
		parameters.btn = btn;
		privateFns.writeOnMap(btn);
	},
};

// Legg til ekstra css-filer
$("head").append("<link rel='stylesheet' type='text/css' href='css/layerSliderPlugin.css' defer>");
export default {
	clearFunction: privateFns.clearFunction,
	createLinkObject: privateFns.createLinkObject,
	linkHandler: privateFns.linkHandler, 
	registerPluginFunction(registerFunction, callback){
		registerFunction({
			id: "layer-slider",
			deactivate: privateFns.deactivate, 
			clear: [privateFns.clearFunction],
			userGuide:{
				img: {type: "icon", className: "fa fa-sliders"},
				text: "Slideren lar deg vise eller skjule deler av et kartlag. Den nederste slideren styrer gjennomsiktigheten av kartlaget. Trykk på <span class='fa fa-refresh'></span> for å oppfriske menyen",
			},
			share: privateFns.createLinkObject,
			handler: privateFns.linkHandler,
			onclick: privateFns.mapSliderClick,
			deactivate: privateFns.deactivate,
		}, callback);
	},
};